import { httpClient } from "@/app/old/desktop/shared/services/";
import { BaseService } from "@/app/old/desktop/shared/services/";
const URL = "fieldValues";

class API extends BaseService {
  constructor() {
    super(null, URL);
  }
  async update(req = {}) {
    return httpClient({
      url: `${this.url}/${req.id}/`,
      baseURL: this.baseURL,
      method: "patch",
      data: req.body,
      header: req.headers,
    }).then(res => res.data);
  }

  async matrix(req = {}) {
    return httpClient({
      url: `${this.url}/matrix/${req.query ? `?${req.query}` : ""}`,
      baseURL: this.baseURL,
      method: "get",
      data: req.body,
      header: req.headers,
    }).then(res => res.data);
  }
}

export const fieldValues = new API();
